var map = {
	"./project/album.svg": "851e",
	"./project/banner_image_blueneutral-desktop.jpg": "ccef",
	"./project/banner_image_blueneutral.jpg": "0885",
	"./project/banner_image_blueneutral_wphoto-desktop.jpg": "37ef",
	"./project/banner_image_blueneutral_wphoto.jpg": "4da7",
	"./project/close.svg": "b44b",
	"./project/next.svg": "f0df",
	"./project/play-icon.svg": "7a13",
	"./project/previous.svg": "5021",
	"./template/image-background-header-desktop.jpg": "5c5b",
	"./template/image-background-header.jpg": "32e0",
	"./template/sample-image-desktop.png": "3100",
	"./template/sample-image.png": "da96",
	"./template/sample-logo.svg": "2bfb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";